'use strict';

import template from './main.html';
import FormHeader from 'app/controllers/form-header.html';

class MainController {
    /* @ngInject */
    constructor(
        $rootScope, $scope, $state, LoginService, $location, PermRoleStore,
        $mdSidenav, $templateCache
    ) {
        Object.assign(this, {LoginService, $state, $location, PermRoleStore,
                             $mdSidenav, $scope });
        this.user = $scope.$parent.$resolve.user;

        // Used by FormController
        $templateCache.put('form-header.html', FormHeader);

        if (!this.user) {
          setTimeout(()=>{ this.$state.go('login'); }, 0);
        }
    }

    logout() {
        this.LoginService.logout().then(() => {
            this.PermRoleStore.clearStore();
            this.user = null;
            this.$location.url('/login');
        });
    }

    toggleSidemenu(id) {
       this.$mdSidenav(id)
            .toggle();
    }

    openUserMenu($mdMenu, ev) {
        $mdMenu.open(ev);
    }

    changePassword() {
        setTimeout(()=>{ this.$state.go('change-password'); }, 0);
    }
}

let mainComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller: MainController
};

export default mainComponent;

